/**
 * Calculate and set the header height as a CSS variable (--header-height)
 * Uses offsetHeight for a stable value that doesn't shrink during scroll transitions,
 * while ResizeObserver handles actual layout changes (like sticky/compressed modes).
 */
/**
 * Calculate and set the header height as a CSS variable (--header-height)
 * Requirement: Include toolbar on load (at top), but exclude it on scroll.
 */
(function() {
  const updateHeaderHeight = () => {
    const toolbar = document.querySelector('.toolbar-section');
    const header = document.querySelector('.site-header__element');
    
    let totalHeight = 0;

    // Only include toolbar height if we are at the very top of the page
    if (window.scrollY <= 0) {
      if (toolbar && toolbar.offsetHeight > 0) {
        totalHeight += toolbar.offsetHeight;
      }
    }

    if (header && header.offsetHeight > 0) {
      totalHeight += header.offsetHeight;
    }

    // Fallback to the group container if sections aren't found or 0
    if (totalHeight === 0) {
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup && headerGroup.offsetHeight > 0) {
        totalHeight = headerGroup.offsetHeight;
      }
    }

    if (totalHeight > 0) {
      document.documentElement.style.setProperty('--header-height', totalHeight.toFixed(2) + 'px');
    }
  };

  // Initial calculation and basic listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  } else {
    updateHeaderHeight();
  }

  window.addEventListener('load', updateHeaderHeight);
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('scroll', updateHeaderHeight);

  // ResizeObserver for theme changes (sticky, compressed, etc.)
  try {
    const observer = new ResizeObserver(() => updateHeaderHeight());
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (headerGroup) observer.observe(headerGroup);
    
    const sections = document.querySelectorAll('.toolbar-section, .header-section');
    sections.forEach(s => observer.observe(s));
  } catch (e) {}

  // Shopify Theme Editor and custom theme event support
  document.addEventListener('shopify:section:load', updateHeaderHeight);
  document.addEventListener('shopify:section:unload', updateHeaderHeight);
  document.addEventListener('headerStickyChange', updateHeaderHeight);
})();
